export default {
  easypaisa__enter_number: 'اپنا ایزی پیسہ نمبر درج کریں',
  easypaisa__enter_number_jazzcash: 'اپنا جاز کیش نمبر درج کریں',
  easypaisa__placeholder: 'مثلاً 03XXXXXXXXX',
  easypaisa__hint: '11 ہندسے، 03 سے شروع ہوتا ہے',
  easypaisa__validation_error: 'درست ایزی پیسہ والٹ نمبر درج کریں\n(11 ہندسے، 03 سے شروع ہوتا ہے)',
  easypaisa__session_timed_out: 'سیشن ختم ہو گیا',
  easypaisa__close: 'بند کریں',
  easypaisa__confirm: 'تصدیق کریں',
  easypaisa__try_again: 'دوبارہ کوشش کریں',
};
